import { createContext } from '@woorcs/utils'

export interface TableStyleContext {
  dense: boolean
  outerPadding: number | string
}

export const [TableStyleProvider, useTableStyle] =
  createContext<TableStyleContext>()
